import { IconProps } from "../../../utils/global-types/global-types";

const ClockFilledIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    className={className ? className : "w-4 h-4"}
    {...rest}
  >
    <path
      fill="#230B34"
      d="M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.6"
      d="M8 4v4l2.667 1.333"
    ></path>
  </svg>
);

export default ClockFilledIcon;
